import { QueryClient } from '@tanstack/react-query';
import { isApiError } from '@finmin/api-client';

/**
 * App-wide TanStack Query client for the customer-facing PWA.
 *
 * Defaults are tuned for a customer dashboard: data is read-mostly and the
 * user often returns to a tab after minutes/hours offline (PWA install).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 10 * 60_000, // longer cache — PWA users come back to existing tabs
      retry: (failureCount, error) => {
        if (isApiError(error)) {
          if (error.status === 0) return failureCount < 2;
          if (error.status >= 400 && error.status < 500) return false;
        }
        return failureCount < 2;
      },
      // Customer dashboard benefits from refetch on focus — they expect "live" status.
      refetchOnWindowFocus: true,
    },
    mutations: { retry: false },
  },
});
